import styled from 'styled-components';

import { mediaConfined, mediaXWide } from '@xing-com/layout-tokens';
import { spaceL } from '@xing-com/tokens';

export const GridIndustries = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${spaceL};

  @media ${mediaConfined} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media ${mediaXWide} {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
`;
